import type React from 'react';
import { useNavigate } from 'react-router-dom';

import checkIcon from '@/assets/icons/check.png';
import errorIcon from '@/assets/icons/error.png';
import { ActionButton, LoadingSpinner } from '@/components/atoms/primitives';
import type { StageProps } from '../types';

export const SuccessStage: React.FC<StageProps> = ({ error, loading }) => {
  const navigate = useNavigate();

  if (loading) {
    return (
      <div className="flex w-1/2 p-16 flex-col justify-center items-center bg-[#0a0e1a] text-white">
        <LoadingSpinner size="lg" />
      </div>
    );
  }

  return (
    <section className="flex w-1/2 p-16 flex-col justify-center items-center bg-[#0a0e1a] text-white">
      <article className="w-full max-w-sm flex flex-col items-center gap-6">
        {error ? (
          <>
            <figure className="flex flex-col items-center gap-2">
              <img src={errorIcon} alt="" className="w-16 h-16" aria-hidden="true" />
              <figcaption className="sr-only">Error icon</figcaption>
            </figure>
            <header className="flex flex-col items-center gap-2">
              <h1 className="text-red-500 font-bold text-center text-lg">
                {typeof error === 'string' ? error : 'An error occurred'}
              </h1>
            </header>
            <p className="text-center text-gray-400 text-sm">
              Please contact{' '}
              <a href="mailto:support@space-eyes.com" className="text-blue-400 hover:text-blue-300 underline">
                support@space-eyes.com
              </a>
            </p>
            <footer>
              <ActionButton
                type="button"
                onClick={() => navigate('/')}
                className="w-full bg-blue-600 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded transition duration-200"
              >
                Log in
              </ActionButton>
            </footer>
          </>
        ) : (
          <>
            <figure className="flex flex-col items-center gap-2">
              <img src={checkIcon} alt="" className="w-16 h-16" aria-hidden="true" />
              <figcaption className="sr-only">Success icon</figcaption>
            </figure>
            <header className="flex flex-col items-center gap-4">
              <h1 className="text-center text-green-500 font-bold text-lg">
                Click the verification link sent to your email to activate account.
              </h1>
              <h2 className="text-center text-white font-medium text-base">
                Congratulations! You now have access to all premium features.
              </h2>
            </header>
            <div className="flex flex-col items-center gap-2">
              <p className="text-center text-gray-400 text-sm">
                Thank you for choosing our service. If you have any questions or need assistance, please don't hesitate
                to contact our support team.
              </p>
              <p className="text-center text-gray-400 text-sm">Enjoy your subscription!</p>
            </div>
            <footer>
              <ActionButton
                type="button"
                onClick={() => navigate('/')}
                className="w-full bg-blue-600 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded transition duration-200"
              >
                Log in
              </ActionButton>
            </footer>
          </>
        )}
      </article>
    </section>
  );
};
